(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["originals-luxury-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__oflAdd) return; window.__oflAdd = true; const oflStep = (g, dir) => { const rtl = getComputedStyle(g).direction === 'rtl' ? -1 : 1; const max = g.scrollWidth - g.clientWidth; const pos = Math.abs(g.scrollLeft); if (dir > 0 && pos >= max - 5) { g.scrollTo({ left: 0, behavior: 'smooth' }); return; } g.scrollBy({ left: dir * rtl * g.clientWidth, behavior: 'smooth' }); }; document.addEventListener('click', (e) => { const b = e.target.closest('[data-ofl-prev],[data-ofl-next]'); if (!b) return; const g = b.closest('.ofl-row').querySelector('.ofl-grid'); oflStep(g, b.hasAttribute('data-ofl-next') ? 1 : -1); }); if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setInterval(() => { document.querySelectorAll('.ofl-row--slider .ofl-grid').forEach((g) => { if (!g.matches(':hover')) oflStep(g, 1); }); }, 4500); }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ofl-add]');
    if (!btn) return;
    e.preventDefault();
    const label = btn.dataset.label || btn.textContent;
    btn.classList.add('is-busy');
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      btn.classList.add('is-done'); btn.textContent = 'Added ✓';
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
      // Let Horizon refresh its cart drawer / bubble when it listens for these events.
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ofl-luxury-home', data: { source: 'ofl-luxury-home', itemCount: cart.item_count } } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
    } catch (err) {
      btn.textContent = 'Try again';
    } finally {
      btn.classList.remove('is-busy');
      setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; }, 2200);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
